module.exports = __webpack_public_path__ + "static/media/web-search-top-search-engines.6f6802ae.png";